import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { ChevronDown, ChevronRight } from "lucide-react";

const CollapsibleSection = ({
  title,
  icon: Icon,
  expanded,
  onToggle,
  badge,
  children,
  className = "",
}) => {
  return (
    <Card className={className}>
      <CardHeader
        className="cursor-pointer hover:bg-accent/50 select-none"
        onClick={onToggle}
      >
        <div className="flex items-center gap-2">
          {Icon && (
            <Icon className="h-4 w-4 text-gray-500 dark:text-gray-400 flex-shrink-0" />
          )}
          <CardTitle className="flex-1">{title}</CardTitle>
          {badge && <div className="flex-shrink-0">{badge}</div>}
          {expanded ? (
            <ChevronDown className="h-4 w-4 text-gray-400 flex-shrink-0" />
          ) : (
            <ChevronRight className="h-4 w-4 text-gray-400 flex-shrink-0" />
          )}
        </div>
      </CardHeader>
      <CardContent className={expanded ? "" : "hidden"}>{children}</CardContent>
    </Card>
  );
};

export default CollapsibleSection;
